module.exports = __webpack_public_path__ + "static/media/icon-calendar-day.c5dce82f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-calendar-day.svg
// module id = 682
// module chunks = 0